import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]
  static values = { key: String }

  connect() {
    const stored = localStorage.getItem(this.storageKey)
    this.isCollapsed = stored === "true"
    this.render()
  }

  toggle() {
    this.isCollapsed = !this.isCollapsed
    localStorage.setItem(this.storageKey, this.isCollapsed)
    this.render()
  }

  render() {
    if (this.hasContentTarget) {
      this.contentTarget.style.display = this.isCollapsed ? "none" : "block"
    }
    if (this.hasIconTarget) {
      this.iconTarget.textContent = this.isCollapsed ? "+" : "-"
    }
  }

  get storageKey() {
    return `collapsible_${this.keyValue || "default"}`
  }
}
